// Comment domain types — mirror the backend contract documented in
// `backend/app/api/routes/comments.py`.

export type CommentTargetType = 'course' | 'program';

export interface CommentAuthor {
  id: string;
  name: string;
  role: string | null;
  avatar_url: string | null;
}

export interface ReactionBucket {
  count: number;
  reacted: boolean;
}

export interface EmojiReactionBucket extends ReactionBucket {
  emoji: string;
}

export interface CommentReactions {
  like: ReactionBucket;
  dislike: ReactionBucket;
  emoji: EmojiReactionBucket[];
}

export interface Comment {
  id: string;
  target_type: CommentTargetType;
  target_id: string;
  parent_id: string | null;
  body: string;
  edited_at: string | null;
  deleted_at: string | null;
  created_at: string | null;
  updated_at: string | null;
  author: CommentAuthor;
  reply_count: number;
  reactions: CommentReactions;
  // Client-only fields used during optimistic create. Never serialized.
  pending?: boolean;
}

export interface CommentPage {
  comments: Comment[];
  next_cursor?: string | null;
}

export interface CreateCommentRequest {
  target_type: CommentTargetType;
  target_id: string;
  parent_id?: string;
  body: string;
}

export interface EditCommentRequest {
  body: string;
}

export type ReactionKind = 'like' | 'dislike' | 'emoji';

export interface ReactionRequest {
  kind: ReactionKind;
  emoji?: string;
}

// Socket.IO event payloads.
export type CommentChangeAction = 'created' | 'updated' | 'deleted' | 'reacted';

export interface CommentsChangedPayload {
  target_type: CommentTargetType;
  target_id: string;
  action: CommentChangeAction;
  comment_id: string;
  parent_id?: string | null;
}

export const COMMENT_EVENTS = {
  CHANGED: 'comments:changed',
  SUBSCRIBE: 'comments:subscribe',
  UNSUBSCRIBE: 'comments:unsubscribe',
} as const;
